import React, { useState } from 'react';
import TextInput from '../fields/TextInput';
import Button from './Button';
import styled from 'styled-components';
import icons from '../../resources/icons/icomoon.svg';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 400px;
  margin: 0 auto;
  box-sizing: border-box;

  @media screen and (max-width: 600px) {
    width: 100%;
    padding: 0 16px;
  }
`;

const SearchButton = styled(Button)`
  width: 40px;
  height: 52px;
  position: relative;
  left: -4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  pointer-events: ${props => (props.disabled ? 'none' : null)};
  background: ${props => (props.disabled ? 'gray' : props.theme.primar)};
`;

const Icon = styled.svg`
  width: 16px;
  height: 16px;
`;

const SearchBar = ({ t, onChange }) => {
  const [value, setValue] = useState('');
  const [searchDisabled, setSearchDisabled] = useState(false);

  const handleSearch = () => {
    if (!searchDisabled) {
      setSearchDisabled(true);
      onChange(value);
      setTimeout(() => setSearchDisabled(false), 1000);
    }
  };

  return (
    <Wrapper>
      <TextInput
        placeholder={t('search_location')}
        inputMargin="16px auto"
        wrapperMargin="0"
        borderColor="#ccc"
        borderRadius="4px"
        leftIcon="icon-location"
        onChange={event => setValue(event.target.value)}
        onKeyPress={event =>
          event.key === 'Enter' && handleSearch(event.target.value)
        }
      />
      <SearchButton
        onClick={() => handleSearch(value)}
        disabled={searchDisabled}
      >
        <Icon>
          <use xlinkHref={`${icons}#icon-search`} />
        </Icon>
      </SearchButton>
    </Wrapper>
  );
};

export default SearchBar;
